'use strict';

export default {
  rulesAdmin: {
    general: {
      title: 'Rules Editor',
      rules: 'Rules',
      ruleName: 'Rule Name',
      untitled: 'untitled',
      twoFields: 'You need at least 2 fields to add rules',
      addNewRule: 'Add New Rule',
      targets: 'Target(s)',
      conditions: 'Condition(s)',
      and: 'AND',
      or: 'OR',
      addNewTarget: 'Add New Target',
      save: 'Save',
      cancel: 'Cancel',
    },
    conditions: {
      lowerThan: 'Lower than (<)',
      lowerThanOrEqualTo: 'Lower than or equal to (≤)',
      equal: 'Equal (=)',
      greaterThanEqualTo: 'Greater than or Equal to (≥)',
      greaterThan: 'Greater than (>)',
      isChecked: 'Is Checked',
      includes: 'Includes',
      isCompleted: 'Is Completed',
    },
    actions: {
      isRequired: 'Is required',
      isVisible: 'Is visible',
    },
    errors: {
      onSave: 'One or more rules have errors to fix.',
      validation1: 'You cannot have conditions using fields from different multiple sections.',
      validation2:
        'One or more of your target uses a field from a multiple section which is not in the same multiple section as other targets or conditions.',
      validation3:
        'One of your targets uses a field which is not a multiple section. When you have a condition or a target using a field from a multiple section, all your targets need to be in the same multiple section.',
    },
  },
};
